import React, { useEffect, useState } from "react";
import Loader from "../../../components/shared/Loader";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../../store/actions/metaAction";
import userPlaceholder from "../../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server, { uploadServer } from "../../../api/server";
import axios from "axios";
import { Select } from "../../../components/shared/FormComponents";
import { getId } from "../../../helpers/functions";

const LinksShow = ({ match }) => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const [socialTypes, setSocialTypes] = useState([]);
	const [selected, setSelected] = useState("");
	const {
		params: { linkId },
	} = match;

	const {
		control,
		register,
		handleSubmit,
		formState: { errors },
		setValue,
		reset,
		watch,
	} = useForm();

	const onStart = async () => {
		try {
			const initialData = await Promise.all([
				server(cookie).get("/settings/socialTypes"),
				server(cookie).get(`/settings/socials/${linkId}`),
			]);
			setSocialTypes([
				...initialData[0].data.data.socialTypes
					// .filter(type => !["phone", "email", "address"].includes(type.name.en))
					.map(type => ({
						...type,
						slug: getId(type),
					})),
			]);

			setValue(
				"socialType",
				getId(initialData?.[1]?.data?.data?.social?.socialType)
			);
			setSelected(getId(initialData?.[1]?.data?.data?.social?.socialType));
			setValue("name", initialData?.[1]?.data?.data?.social?.name);
			setValue("link", initialData?.[1]?.data?.data?.social?.link);

			dispatch(
				updateMeta({
					title: `${initialData?.[1]?.data?.data?.name?.ar ?? " "}`,
					breadcrumb: "الرابط",
					button: {
						show: false,
						text: null,
						link: null,
					},
				})
			);
		} catch (error) {
			console.log(error);
		}
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const finalData = {
				...data,
				// socialType: data.socialType ?? selected.id,
				// name: data.name,
				// link: data.link,
			};
			const dataResponse = await server(cookie).put(
				`/settings/socials/${linkId}`,
				finalData
			);
			reset();
			onStart();
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	// watchers
	useEffect(() => {
		onStart();
	}, []);

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					<div className="col-md-12">
						<div className="card">
							{!["phon", "email", "address"].includes(selected?.name?.en) && (
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="socialType">نوع الرابط</label>
										<Select
											control={control}
											id="socialType"
											name="socialType"
											required={true}
											options={socialTypes}
											register={register}
											selectedValue={selected}
										/>
									</div>
								</div>
							)}
							{socialTypes.find(type => getId(type) === selected)?.name.en !==
							"working hours" ? (
								<div className="card-body">
									<div className="form-item">
										<label htmlFor="nameEn">رابط التواصل</label>
										<input
											type="text"
											name="link"
											id="link"
											{...register("link", {
												required: true,
											})}
										/>
									</div>
								</div>
							) : (
								<>
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="nameAr">الموعيد بالغة العربية</label>
											<input
												type="text"
												name="name"
												id="nameAr"
												{...register("name.ar", {
													required: true,
												})}
											/>
										</div>
									</div>
									{/* "https://www.facebook.com/Ejadhcompan66w" */}
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="nameEn">الموعيد بالغة الانجليزية</label>
											<input
												type="text"
												name="name"
												id="nameEn"
												{...register("name.en", {
													required: true,
												})}
											/>
										</div>
									</div>
								</>
							)}
						</div>
					</div>

					<div className="form-item mt-3">
						<button className="bt bt-success btn-block">ارسال</button>
					</div>
				</div>
				<input
					type="text"
					name="name"
					id=""
					style={{ display: "none" }}
					{...register("name")}
				/>
				<input
					type="text"
					name="socialType"
					id=""
					style={{ display: "none" }}
					{...register("socialType")}
				/>
			</form>
		</section>
	);
};

export default LinksShow;
